import React from "react";
import ProductTable from "src/pages/product";

export default function ProductPage() {
  return <ProductTable />;
}
